import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { ITooltipsDto } from "../../../features/globals/interface/dto/tooltips.dto";
import { get } from "../../../service/api";
import { TooltipPageId } from "../enums/tooltip.enum";

export const getTooltips = (
    pageId: TooltipPageId,
    tokens: ITokenPair,
): Observable<Array<ITooltipsDto>> =>
    get<Array<ITooltipsDto>>(`/content/tooltips/${pageId}`, undefined, tokens);
